<script setup lang="ts">
import { ref } from "vue";
import RvApi from "@/rvapi";
const searching = ref(false);
const search = async () => {
  searching.value = true;
  const qs = q.value
    .split("\n")
    .map((qq) => encodeURIComponent(qq.trim()))
    .filter((qq) => qq.length > 0);
  try {
    data.value = await RvApi.searchLegacy(searchType.value, qs);
    if (data.value && data.value.length) {
      props.value = Object.keys(data.value[0]);
    } else {
      props.value = [];
    }
  } catch (e) {
    console.log(e);
  }
  searching.value = false;
};
const q = ref("");
const data = ref([] as any[]);
const props = ref([] as string[]);
const searchType = ref("application/id");
const searchTypes = [
  "transaction/application",
  "transaction/id",
  "transaction/customerno",
  "eventlog/application",
  "sendlog/application",
  "postcard/ordernr",
  "postcard/transaction",
  "postcard/application",
  "device/id",
  "application/customerno",
  "application/email",
  "application/device",
  "application/id",
];
const copy = (prop: string, event: any) => {
  const str = data.value
    .map((d) => d[prop].trim())
    .filter((d) => d.length > 0)
    .join("\n");
  if (str) {
    event.target.classList.add("copied");
    setTimeout(() => event.target.classList.remove("copied"), 5000);
    window.navigator.clipboard.writeText(str);
  }
};
</script>

<template>
  <p>
    <select v-model="searchType">
      <option disabled value="">Please select one</option>
      <option v-for="s in searchTypes" :key="s">{{ s }}</option>
    </select>
  </p>
  <textarea v-model="q"></textarea>
  <p>
    <pn-button @click="search" small="true" :loading="searching">Go</pn-button>
  </p>
  <table>
    <tr>
      <th v-for="p in props" :key="p">
        {{ p }} <a @click="(e) => copy(p, e)">(copy)</a><span>Copied!</span>
      </th>
    </tr>
    <tr v-for="(d, i) in data" :key="i">
      <td v-for="pp in props" :key="`${i}-${pp}`">
        {{ d[pp] }}
      </td>
    </tr>
  </table>
</template>
<style lang="scss" scoped>
textarea {
  min-width: 600px;
}

td,
td {
  border: 1px silver solid;
}

th > a {
  cursor: pointer;
  font-weight: normal;
  transition: all 0.5s;
}
th > a + span {
  display: none;
  color: darkgreen;
  border: 1px solid darkgreen;
  border-radius: 4px;
  padding: 3px;
  background: #9d9;
}
th > a.copied {
  display: none;
}
th > a.copied + span {
  display: inline;
}

th > a:hover {
  text-decoration: underline;
}
</style>
